import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37afaaa9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-menu__container" }
const _hoisted_2 = { class: "content-menu__header" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonTab = _resolveComponent("ButtonTab")!
  const _component_ContentList = _resolveComponent("ContentList")!
  const _component_ContentAnnotation = _resolveComponent("ContentAnnotation")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['content-menu', { collapsed: !_ctx.isMenuOpen }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_ButtonTab, {
          type: "content",
          title: "Conteúdos",
          "is-active": _ctx.isContentListActive,
          onClick: _ctx.onClickButtonContent
        }, null, 8, ["is-active", "onClick"]),
        _createVNode(_component_ButtonTab, {
          type: "annotation",
          title: "Anotações",
          "is-active": _ctx.isContentAnnotationActive,
          onClick: _ctx.onClickButtonAnnotation
        }, null, 8, ["is-active", "onClick"])
      ]),
      _createVNode(_component_ContentList, {
        class: _normalizeClass(['content-menu__contents', { inactive: !_ctx.isContentListActive }])
      }, null, 8, ["class"]),
      _createVNode(_component_ContentAnnotation, {
        class: _normalizeClass([
          'content-menu__annotations',
          { inactive: _ctx.isContentListActive }
        ])
      }, null, 8, ["class"])
    ]),
    _createElementVNode("button", {
      class: _normalizeClass(['content-menu__toggle', { collapsed: !_ctx.isMenuOpen }]),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickMenuButton && _ctx.onClickMenuButton(...args)))
    }, null, 2)
  ], 2))
}